module.exports = __webpack_public_path__ + "img/friend3.45a15eac.png";